// extracted by mini-css-extract-plugin
export default {"main":"TopRelationshipsToMyExecutives_main__Dssfj","sidebarLegend":"TopRelationshipsToMyExecutives_sidebarLegend__IDcpn","graph":"TopRelationshipsToMyExecutives_graph__n1a+g"};